<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">编辑400号码</h1>
            <div class="hot-line-con">
                <p>注</p>
                <p>1、公共大号类型：默认关联平台代理商，与站点为1对多的关系;</p>
                <p>2、独立大号类型：与站点为1对1的关系；</p>
                <p>3、分机号位数：绑定后不可修改，如配置2位数，则一个号码下可使用的分机号数量为“10^2”=100个；</p>
            </div>
            <el-form class="form-container" :model="info" :rules="rules" ref="hotlineForm">
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">号码类型</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="type">
                            <el-select v-model="info.type" placeholder="请选择"  >

                                <el-option v-for="items in typeMap" :key="items.id" :label="items.name" :value="items.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">是否直拔号</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="only_user_400">
                            <el-select v-model="info.only_user_400" placeholder="请选择"  >
                                <el-option v-for="items in onlyUser400Map" :key="items.id" :label="items.name" :value="items.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">分机号位数</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item  prop="telephone_length">
                            <el-select v-model="info.telephone_length"  disabled placeholder="请选择"  >
                                <el-option v-for="items in numbers" :key="items.id" :label="items.name" :value="items.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">备注</span>
                        <label class="warn"></label>
                    </div>
                    <div class="form-input-item">
                        <el-form-item label="" prop="remark">
                            <el-input placeholder="请输入备注,不能超过150个字" type="textarea" class="input-control" v-model="info.remark" show-word-limit maxlength="150"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-button">
                    <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
                    <el-button type="primary" @click="submitForm('hotlineForm')">确 认</el-button>
                </div>
            </el-form>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import {editHotlines} from "../../../../service/hotline";
    export default {
        name: "edit",
        components: {
            PopoverRight
        },
        props: {
            callback: Function
        },
        data () {
            return {
                typeMap:[
                    {id:"",name:"请选择号码类型"},
                    {id:2,name:"公共号码"},
                    {id:1,name:"独立号码"}
                ],
                onlyUser400Map: [
                    {id: 1, name: "是"},
                    {id: 0, name: "否"}
                ],
                numbers:[
                    {id:0,name:"0"},
                    {id:1,name:"1"},
                    {id:2,name:"2"},
                    {id:3,name:"3"},
                    {id:4,name:"4"},
                    {id:5,name:"5"},
                    {id:6,name:"6"},
                ],
                info: {
                    type:"",
                    id: "",
                    name: "",
                    remark:"",
                    telephone_length:"",
                    only_user_400: "",
                },
                rules: {
                    type: [
                        { required: true, message: '请填写号码类型', trigger: 'blur' },
                    ],
                    telephone_length: [
                        { required: true, message: '请填写分机号位数', trigger: 'blur' },
                    ],
                    remark: [
                        {min:0,max:150,message:'不能超过150个字'}
                    ],
                },
            }
        },
        methods : {
            async open () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.resetForm();
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.$refs.hotlineForm && this.$refs.hotlineForm.clearValidate()

            },
            resetForm () {
                this.info = {
                    hotline_number:"",
                    type:"",
                    providerId: "",
                    name: "",
                    remark:"",
                    telephone_length:"",
                    only_user_400: "",
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        let id = this.info.id;
                        var query = {
                            type: this.info.type,
                            telephone_length:this.info.telephone_length,
                            remark:this.info.remark,
                            only_user_400:this.info.only_user_400,
                        };
                        editHotlines(id,query).then((data) => {
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            });
                            this.hide();
                            this.callback && this.callback()
                        }).catch(err => {
                            this.$message({
                                message: err.message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>

<style scoped>
.hot-line-con{
    background: #fafafa;
    padding: 10px 20px;
    line-height: 24px;
    margin-top: 20px;
}
</style>